import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import PropTypes from 'prop-types';
import React from 'react';
import { getViewportInfo, isClient } from '@tcp/core/src/utils';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { slpSubLabels, SLP_SUB_LABELS } from '@tcp/core/src/utils/labels/browse/SLP.labels';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import style from '../styles/TrendingSearchList.style';
import { getIsTabletWebSearch, getIsMobileWebSearch } from '../utils/NewSearchBar.util';

const TrendingSearchList = (props) => {
  const {
    className,
    trendingSearchList,
    closeSearchBar,
    navigateToUrl,
    onCloseClick,
    isCmsTrending,
  } = props;
  const slpLabels = getLabelFromCopyOrFromTranslation(SLP_SUB_LABELS, slpSubLabels);

  const trendingSearchesLabelText = renderLabel(
    slpLabels?.lbl_trending_searches,
    'lbl_trending_searches'
  );

  const { isMobile } = (isClient() && getViewportInfo()) || {};
  const renderTrendingSearches = () => {
    return (
      <div className={`${className} search trending-search-list`}>
        <BodyCopy fontFamily="secondary" className="trending-search-title">
          {trendingSearchesLabelText}
        </BodyCopy>
        <ul className="trending-search-items">
          {trendingSearchList &&
            trendingSearchList.map((item, index) => {
              const isRedirection = isCmsTrending && item.redirectUrl;
              const routeTerm = isCmsTrending ? item.searchTerm : item;
              const toPath = `/search/${routeTerm}`;
              const key = `${routeTerm}_${index}`;
              return (
                <BodyCopy
                  component="li"
                  fontFamily="secondary"
                  fontSize="fs14"
                  className={`trending-search-list-item ${isMobile ? 'mobile-viewport' : ''}`}
                  tabIndex="0"
                  key={key}
                  onKeyPress={(e) => {
                    e.preventDefault();
                    closeSearchBar(e);
                    navigateToUrl(isRedirection, item.redirectUrl, routeTerm);
                  }}
                >
                  <Anchor
                    className="trending-anchor"
                    tabIndex="-1"
                    to={toPath}
                    onClick={(e) => {
                      e.preventDefault();
                      if (getIsTabletWebSearch() || getIsMobileWebSearch()) {
                        onCloseClick(e);
                      }
                      closeSearchBar(e);
                      navigateToUrl(isRedirection, item.redirectUrl, routeTerm);
                    }}
                  >
                    {routeTerm}
                  </Anchor>
                </BodyCopy>
              );
            })}
        </ul>
      </div>
    );
  };
  return <div className={`${className} trending-search-wrapper`}>{renderTrendingSearches()}</div>;
};

TrendingSearchList.propTypes = {
  className: PropTypes.string.isRequired,
  trendingSearchList: PropTypes.arrayOf(PropTypes.string),
  closeSearchBar: PropTypes.func.isRequired,
  navigateToUrl: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
};

TrendingSearchList.defaultProps = {
  trendingSearchList: [],
};

export { TrendingSearchList as TrendingSearchListVanilla };
export default withStyles(TrendingSearchList, style);
